import React from 'react';

const Profile = () => {
  return (
    <div>
      <div className="row">
        <div className="col-xl-4">
          <div className="card">
            <div className="card-body profile-card pt-4 d-flex flex-column align-items-center">
              <img src="assets/img/profile-img.jpg" alt="Profile" className="rounded-circle" />
              <h2 className='mt-3'>Kevin Anderson</h2>
              <h3 className=''>Web Designer</h3>
              <div className="tab-pane fade show active profile-overview mt-3" id="profile-overview">
                <h5 className="card-title">About</h5>
                <p className="small fst-italic">Sunt est soluta temporibus accusantium neque nam maiores cumque temporibus. Tempora libero non est unde veniam est qui dolor. Ut sunt iure rerum quae quisquam autem eveniet perspiciatis odit. Fuga sequi sed ea saepe at unde.</p>

                <h5 className="card-title">Profile Details</h5>
                <div className="row pt-2">
                  <div className="col-lg-3 col-md-4 label ">Full Name</div>
                  <div className="col-lg-9 col-md-8">Kevin Anderson</div>
                </div>
                <div className="row pt-2">
                  <div className="col-lg-3 col-md-4 label">Company</div>
                  <div className="col-lg-9 col-md-8">Lueilwitz, Wisoky and Leuschke</div>
                </div>
                <div className="row pt-2">
                  <div className="col-lg-3 col-md-4 label">Job</div>
                  <div className="col-lg-9 col-md-8">Web Designer</div>
                </div>
                <div className="row pt-2">
                  <div className="col-lg-3 col-md-4 label">Country</div>
                  <div className="col-lg-9 col-md-8">USA</div>
                </div>
                <div className="row pt-2">
                  <div className="col-lg-3 col-md-4 label">Address</div>
                  <div className="col-lg-9 col-md-8">A108 Adam Street, New York, NY 535022</div>
                </div>
                <div className="row pt-2">
                  <div className="col-lg-3 col-md-4 label">Phone</div>
                  <div className="col-lg-9 col-md-8">(436) 486-3538 x29071</div>
                </div>
                <div className="row pt-2">
                  <div className="col-lg-3 col-md-4 label">Email</div>
                  <div className="col-lg-9 col-md-8">k.anderson@example.com</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-8">
          <div className="card">
            <div className="card-body pt-3">
              <ul className="nav nav-tabs nav-tabs-bordered">
                <li className="nav-item">
                  <button className="nav-link" data-bs-toggle="tab" data-bs-target="#profile-edit">Edit Profile</button>
                </li>
                <li className="nav-item">
                  <button className="nav-link" data-bs-toggle="tab" data-bs-target="#profile-settings">Settings</button>
                </li>
                <li className="nav-item">
                  <button className="nav-link" data-bs-toggle="tab" data-bs-target="#profile-change-password">Change Password</button>
                </li>
              </ul>
              <div className="tab-content pt-2">

                <div className="tab-pane show active fade profile-edit pt-3" id="profile-edit">
                  <form>
                    <div className="row mb-3">
                      <label htmlFor="profileImage" className="col-md-4 col-lg-3 col-form-label">Profile Image</label>
                      <div className="col-md-8 col-lg-9">
                        <img src="assets/img/profile-img.jpg" alt="Profile" />
                        <div className="pt-2">
                          <a href="#" className="btn btn-primary btn-sm" title="Upload new profile image"><i className="bi bi-upload"></i></a>
                          <a href="#" className="btn btn-danger btn-sm ml-2" title="Remove my profile image"><i className="bi bi-trash "></i></a>
                        </div>
                      </div>
                    </div>

                    <div className="row mb-3">
                      <label htmlFor="fullName" className="col-md-4 col-lg-3 col-form-label">Full Name</label>
                      <div className="col-md-8 col-lg-9">
                        <input name="fullName" type="text" className="form-control" id="fullName" value="Kevin Anderson" />
                      </div>
                    </div>

                    <div className="row mb-3">
                      <label htmlFor="about" className="col-md-4 col-lg-3 col-form-label">About</label>
                      <div className="col-md-8 col-lg-9">
                        <textarea name="about" className="form-control" id="about" style={{ height: '100%' }}>Sunt est soluta temporibus accusantium neque nam maiores cumque temporibus. Tempora libero non est unde veniam est qui dolor. Ut sunt iure rerum quae quisquam autem eveniet perspiciatis odit. Fuga sequi sed ea saepe at unde.</textarea>
                      </div>
                    </div>

                    <div className="row mb-3">
                      <label htmlFor="company" className="col-md-4 col-lg-3 col-form-label">Company</label>
                      <div className="col-md-8 col-lg-9">
                        <input name="company" type="text" className="form-control" id="company" value="Lueilwitz, Wisoky and Leuschke" />
                      </div>
                    </div>

                    <div className="row mb-3">
                      <label htmlFor="Job" className="col-md-4 col-lg-3 col-form-label">Job</label>
                      <div className="col-md-8 col-lg-9">
                        <input name="job" type="text" className="form-control" id="Job" value="Web Designer" />
                      </div>
                    </div>

                    <div className="row mb-3">
                      <label htmlFor="Country" className="col-md-4 col-lg-3 col-form-label">Country</label>
                      <div className="col-md-8 col-lg-9">
                        <input name="country" type="text" className="form-control" id="Country" value="USA" />
                      </div>
                    </div>

                    <div className="row mb-3">
                      <label htmlFor="Address" className="col-md-4 col-lg-3 col-form-label">Address</label>
                      <div className="col-md-8 col-lg-9">
                        <input name="address" type="text" className="form-control" id="Address" value="A108 Adam Street, New York, NY 535022" />
                      </div>
                    </div>

                    <div className="row mb-3">
                      <label htmlFor="Phone" className="col-md-4 col-lg-3 col-form-label">Phone</label>
                      <div className="col-md-8 col-lg-9">
                        <input name="phone" type="text" className="form-control" id="Phone" value="(436) 486-3538 x29071" />
                      </div>
                    </div>

                    <div className="row mb-3">
                      <label htmlFor="Email" className="col-md-4 col-lg-3 col-form-label">Email</label>
                      <div className="col-md-8 col-lg-9">
                        <input name="email" type="email" className="form-control" id="Email" value="k.anderson@example.com" />
                      </div>
                    </div>

                    <div className="text-center">
                      <button type="submit" className="btn btn-primary">Save Changes</button>
                    </div>
                  </form>
                </div>

                <div className="tab-pane fade pt-3" id="profile-settings">
                  <form>
                    <div className="row mb-3">
                      <label htmlFor="fullName" className="col-md-4 col-lg-3 col-form-label">Email Notifications</label>
                      <div className="col-md-8 col-lg-9">
                        <div className="form-check">
                          <input className="form-check-input" type="checkbox" id="changesMade" checked />
                          <label className="form-check-label" htmlFor="changesMade">
                            Changes made to your account
                          </label>
                        </div>
                        <div className="form-check">
                          <input className="form-check-input" type="checkbox" id="newProducts" checked />
                          <label className="form-check-label" htmlFor="newProducts">
                            New products and updates
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="text-center">
                      <button type="submit" className="btn btn-primary">Save Changes</button>
                    </div>
                  </form>
                </div>

                <div className="tab-pane fade pt-3" id="profile-change-password">
                  <form>
                    <div className="row mb-3">
                      <label htmlFor="currentPassword" className="col-md-4 col-lg-3 col-form-label">Current Password</label>
                      <div className="col-md-8 col-lg-9">
                        <input name="currentPassword" type="password" className="form-control" id="currentPassword" />
                      </div>
                    </div>

                    <div className="row mb-3">
                      <label htmlFor="newPassword" className="col-md-4 col-lg-3 col-form-label">New Password</label>
                      <div className="col-md-8 col-lg-9">
                        <input name="newPassword" type="password" className="form-control" id="newPassword" />
                      </div>
                    </div>

                    <div className="row mb-3">
                      <label htmlFor="confirmPassword" className="col-md-4 col-lg-3 col-form-label">Confirm New Password</label>
                      <div className="col-md-8 col-lg-9">
                        <input name="confirmPassword" type="password" className="form-control" id="confirmPassword" />
                      </div>
                    </div>

                    <div className="text-center">
                      <button type="submit" className="btn btn-primary">Change Password</button>
                    </div>
                  </form>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
